module.exports = __webpack_public_path__ + "img/homes_step2.2b6bb4a9.svg";